import React, { Component, Fragment } from 'react'
import { LanguageConsumer, Translate } from '../../../contexts/LanguageContext';
import { Loading, BreadCrumb, Card, UserAccounts, Validator, ErrorMessage, Modal } from '../../../components';
import { Rules, PaymentConfirm, Currencies, TransferOptionUrl } from '../../../components/Payment';
import { Tooltip } from 'reactstrap';
import { TransferOptionService } from '../../../services/TransferOptionService';
import { UserService } from '../../../services/UserService';
import { WithdrawalService } from '../../../services/WithdrawalService';

export class BankAccountWithdrawal extends Component {

    constructor(props) {
        super(props)

        this.Refs = React.createRef();


        this.state = {
            loading: true,
            confirm: false,
            tooltipAvailableMargin: false,
            success: false,
            paymentOptions: {
                acceptedCurrencies: [],
                description: "",
                rules: [],
                title: ""
            },
            availableMargin: 0,
            accountCurrency: "",
            bankAccountList: [],
            // Payment Form
            login: 0,
            amount: 0,
            currency: "",
            validation: {
                error: false,
                message: ""
            },
            bankAccountDetailShow: false,
            bankAccountDetail: {
                account_Number: "",
                bank_Name: "",
                iban: "",
                swift: "",
            },
        }

    }
    componentWillMount() {

        TransferOptionService.Withdrawal.OptionPage(TransferOptionUrl()).then(response => {

            if (!response) {
               document.location.href = "/withdrawal";
                return false;
            }


            this.setState({
                paymentOptions: response,
                loading: false,
                error: false
            })
        });
    }
    changeAccount(userAccount) {
        this.setState({
            login: userAccount.active,
            availableMargin: userAccount.info.availableMargin.toFixed(2),
            accountCurrency: userAccount.info.currency,
            amount: 0,
            loading: true
        }, () => {


            UserService.CustomerBankAccountList({ login: userAccount.active }).then(response => {

                if (response)
                    this.setState({
                        bankAccountList: response,
                        loading: false,
                    });

            });

        });
    }
    onChangeForm(e, key) {

        let value = e.target.value;

        if (key === "amount" && parseFloat(value) > this.state.availableMargin)
            value = this.state.availableMargin;

        if (key === "bankAccount") {
            if (parseInt(value) === -1) {
                this.setState({ currency: "", bankAccountDetailShow: false });

            } else {
                this.state.bankAccountList.forEach(item => {
                    if (item.value === parseInt(value))
                        this.setState({ currency: item.currency, bankAccountTitle: item.title, bankAccountDetailShow: true, bankAccountDetail: item.detail });
                });
            }
        }
        this.setState({
            [key]: value
        });
    }
    onAvailableMargin() {

        this.setState({
            amount: this.state.availableMargin
        });
    }
    onToggleWithdrawal() {
        if (this.isValid())
            this.setState(prevState => ({
                confirm: !prevState.confirm
            }), () => {
                if (!this.state.confirm) {
                    this.setState({
                        bankAccount: "-1",
                        currency: ""
                    })
                }
            });
    }
    isValid() {


        if (!this.state.confirm) {

            console.log(this.state.bankAccount, "------------bn");
            let error = Validator.Valid({
                amount: this.state.amount,
                bankAccount: this.state.bankAccount,
                currency: this.state.currency
            }, this.Refs);

            this.setState({
                validation: error
            });

            return !error.error;
        }

        return true;
    }
    onConfirmWithdrawal() {
        this.setState({ loading: true }, () => {

            WithdrawalService.BankAccount({
                login: this.state.login,
                amount: this.state.amount,
                currency: this.state.currency,
                bankAccount: this.state.bankAccount
            }).then(response => {

                if (response) {
                    this.setState({
                        loading: false,
                        success: !response.error,
                        validation: {
                            error: response.error,
                            message: response.message
                        }
                    });
                } else {
                    this.setState({
                        loading: false,
                        validation: {
                            error: true,
                            message: "Temporary error!"
                        }
                    });
                }
            });

        });
    }
    onSave() {

        this.setState({ loading: true }, () => {

            UserService.CustomerBankAccountAdd({
                login: this.state.login,
                accountTitle: this.state.accountTitle,
                accountNumber: this.state.accountNumber,
                bankName: this.state.bankName,
                iban: this.state.iban,
                swift: this.state.swift,
                accountCurrency: this.state.accountCurrency
            }).then(response => {

                if (response) {
                    this.setState({
                        loading: false,
                        bankAccountList: response,
                        modal: false
                    });
                } else {
                    this.setState({
                        loading: false
                    });

                }

            });
        });
    }

    render() {
        return (
            <LanguageConsumer>
                {() => (
                    <Fragment>
                        <Loading Show={this.state.loading} Title={Translate("Loading Content")} />
                        <BreadCrumb Title={this.state.paymentOptions.title} Name={this.state.paymentOptions.title} SubTitle={Translate("Withdrawal")} SubUrl="/withdrawal" />
                        <Modal Title={Translate("Add Bank Account")} Show={this.state.modal} onClose={(e) => this.setState({ modal: false })}>
                            <div className="row mt-1 mb-1">
                                <div className="col-md-12">
                                    <form className="form-horizontal" name="saveForm" ref={this.Refs}>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="accountTitle" className="col-sm-4 col-form-label">{Translate("Account Title")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="accountTitle" name="accountTitle" onChange={(e) => this.onChangeForm(e, "accountTitle")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="accountNumber" className="col-sm-4 col-form-label">{Translate("Account Number")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="accountNumber" name="accountNumber" onChange={(e) => this.onChangeForm(e, "accountNumber")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="bankName" className="col-sm-4 col-form-label">{Translate("Bank Name")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="bankName" name="bankName" onChange={(e) => this.onChangeForm(e, "bankName")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="iban" className="col-sm-4 col-form-label">{Translate("IBAN")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="iban" name="iban" onChange={(e) => this.onChangeForm(e, "iban")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="swift" className="col-sm-4 col-form-label">{Translate("Swift")}</label>
                                            <div className="col-sm-8">
                                                <input className="form-control" type="text" id="swift" name="swift" onChange={(e) => this.onChangeForm(e, "swift")} />
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="accountCurrency" className="col-sm-4 col-form-label">{Translate("Account Currency")}</label>
                                            <div className="col-sm-8">
                                                <select className="form-control" id="accountCurrency" name="accountCurrency" onChange={(e) => this.onChangeForm(e, "accountCurrency")}>
                                                    <option value="USD">USD</option>
                                                    <option value="EUR">EUR</option>
                                                    <option value="GBP">GBP</option>
                                                    <option value="RMB">RMB</option>
                                                    <option value="PLN">PLN</option>
                                                    <option value="TRY">TRY</option>
                                                    <option value="VND">VND</option>
                                                    <option value="THB">THB</option>
                                                    <option value="MYR">MYR</option>
                                                    <option value="IDR">IDR</option>
                                                </select>
                                            </div>
                                        </div>
                                        <div className="form-group row ml-1 mr-1">
                                            <label htmlFor="save-form" className="col-sm-4 col-form-label"></label>
                                            <div className="col-sm-8">
                                                <button type="button" className="btn btn-info float-right" onClick={(e) => this.onSave()}><i className="far fa-save mr-1"></i> Save Form</button>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </Modal>
                        <Card Title={this.state.paymentOptions.title} Description={this.state.paymentOptions.description} Logo={this.state.paymentOptions.logo}>
                            <div className="row">
                                <div className="col-md-12">
                                    <Rules Items={this.state.paymentOptions.rules} />
                                </div>
                                <ErrorMessage Validation={this.state.validation} />
                                {!this.state.confirm ?
                                    <div className="col-md-12">
                                        <form className="form-horizontal" name="depositForm" ref={this.Refs}>
                                            <h4 className="mt-0 header-title m-b-20 mt-4 text-dark"><i className="fas fa-file-invoice"></i>{Translate("&nbsp; Payment Form")}</h4>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label">{Translate("Account")}</label>
                                                <div className="col-sm-5">
                                                    <UserAccounts OnlyInfo Witdrawal className="bg-dark" Change={(e, userAccount) => this.changeAccount(userAccount)} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="amount" className="col-sm-2 col-form-label">{Translate("Amount")}</label>
                                                <div className="col-sm-5">
                                                    <div className="input-group">
                                                        <input className="form-control" type="number" id="amount" value={this.state.amount} onChange={(e) => this.onChangeForm(e, "amount")} onFocus={e => e.target.select()} />
                                                        <div className="input-group-append hide">
                                                            <button type="button" className="input-group-text pt-0 pb-0 bg-white" id="availableMargin" onClick={(e) => this.onAvailableMargin()}>
                                                                {this.state.availableMargin + " " + this.state.accountCurrency}
                                                            </button>
                                                            <Tooltip placement="right" isOpen={this.state.tooltipAvailableMargin} target="availableMargin" toggle={() => this.setState({ tooltipAvailableMargin: !this.state.tooltipAvailableMargin })}>
                                                                {Translate("Available Margin")}
                                                            </Tooltip>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="bankAccount" className="col-sm-2 col-form-label">{Translate("Bank Account")}</label>
                                                <div className="col-sm-5">
                                                    <div className="input-group">
                                                        <select className="form-control" id="bankAccount" name="bankAccount" onChange={(e) => this.onChangeForm(e, "bankAccount")}>
                                                            <option value="-1">{Translate("Select Bank Account")}</option>
                                                            {this.state.bankAccountList.map(item => <option value={item.value}>{item.title}</option>)}
                                                        </select>
                                                        <div className="input-group-append hide">
                                                            <button type="button" className="btn btn-info" onClick={(e) => this.setState({ modal: true })}>Add Account</button>
                                                        </div>
                                                    </div>

                                                </div>

                                            </div>
                                            {/* BANK ACCOUNT DETAIL */}
                                            {this.state.bankAccountDetailShow && (
                                                <>
                                                    <div className="form-group row ml-3">
                                                        <label className="col-sm-2 col-form-label">{Translate("Account Number")}</label>
                                                        <div className="col-sm-5">
                                                            {this.state.bankAccountDetail.account_Number}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row ml-3">
                                                        <label className="col-sm-2 col-form-label">{Translate("Bank Name")}</label>
                                                        <div className="col-sm-5">
                                                            {this.state.bankAccountDetail.bank_Name}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row ml-3">
                                                        <label className="col-sm-2 col-form-label">{Translate("IBAN")}</label>
                                                        <div className="col-sm-5">
                                                            {this.state.bankAccountDetail.iban}
                                                        </div>
                                                    </div>
                                                    <div className="form-group row ml-3">
                                                        <label className="col-sm-2 col-form-label">{Translate("Swift")}</label>
                                                        <div className="col-sm-5">
                                                            {this.state.bankAccountDetail.swift}
                                                        </div>
                                                    </div>
                                                </>
                                            )}
                                            {/* BANK ACCOUNT DETAIL END */}
                                            <div className="form-group row ml-3">
                                                <label htmlFor="currency" className="col-sm-2 col-form-label">{Translate("Currency")}</label>
                                                <div className="col-sm-5">
                                                    <Currencies Items={[this.state.currency]} id="currency" onChange={(e) => this.onChangeForm(e, "currency")} />
                                                </div>
                                            </div>
                                            <div className="form-group row ml-3">
                                                <label htmlFor="example-text-input" className="col-sm-2 col-form-label"></label>
                                                <div className="col-sm-5">
                                                    <button type="button" className="btn btn-lg btn-success" onClick={(e) => this.onToggleWithdrawal()}>{Translate("Create a Withdrawal Request")}</button>
                                                </div>
                                            </div>
                                        </form>
                                    </div>
                                    :
                                    <PaymentConfirm Form={[
                                        {
                                            title: Translate("Account"),
                                            value: this.state.login
                                        },
                                        {
                                            title: Translate("Amount"),
                                            value: this.state.amount.format('c') + " " + this.state.currency
                                        },
                                        {
                                            title: Translate("Bank Account"),
                                            value: this.state.bankAccountTitle
                                        }

                                    ]} Cancel={(e) => this.onToggleWithdrawal()} Confirm={(e) => this.onConfirmWithdrawal()} Success={this.state.success} CancelButtonTitle={Translate('Cancel Withdrawal')} ConfirmButtonTitle={Translate('Confirm Withdrawal')} />
                                }
                            </div>
                        </Card>
                    </Fragment>
                )}
            </LanguageConsumer>
        )
    }
}